import styles from "./AffProgram.module.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Icon1 from "../../imgs/icon5.svg";
import Icon2 from "../../imgs/icon6.svg";
import Icon3 from "../../imgs/icon7.svg";
import Light from "../../imgs/light.svg";

export default function AffProgram() {
  const { t } = useTranslation();

  return (
    <div className={styles.affprogram_page}>
      <Header />
      <div className={styles.section1}>
        <img className={styles.light} src={Light} />
        <div className={styles.section1Body}>
          <div className={styles.top}>
            <h1>{t("Affiliate Program")}</h1>
            <h2>
              {t(
                "Become a Synergy Assets partner and earn high income on individual terms!"
              )}
            </h2>
            <p>
              {t(
                "The affiliate program from the cryptocurrency broker Synergy Assets is:"
              )}
            </p>
          </div>
          <div className={styles.bottom}>
            <div className={styles.blocks}>
              <div className={styles.top_blocks}>
                <div className={styles.block}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="41"
                    height="40"
                    viewBox="0 0 41 40"
                    fill="none"
                  >
                    <path
                      d="M34 25.921C32.0438 32.1492 26.2252 36.667 19.3514 36.667C10.8731 36.667 4 29.7939 4 21.3156C4 14.4418 8.51775 8.62316 14.746 6.66699"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M37.1885 16.5785C35.4192 10.2403 30.426 5.2471 24.0879 3.47784C21.3486 2.71318 19 5.08999 19 7.93404V19.0915C19 20.5136 20.1528 21.6663 21.5748 21.6663H32.7323C35.5764 21.6663 37.9532 19.3178 37.1885 16.5785Z"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                    />
                  </svg>
                  <p>
                    {t("Traffic monetization by multilingual segments: CIS")}
                  </p>
                </div>
                <div className={styles.block}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                  >
                    <path
                      d="M5 36.667H35"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5 18.3333C5 16.762 5 15.9763 5.48816 15.4882C5.97631 15 6.76199 15 8.33333 15C9.90468 15 10.6904 15 11.1785 15.4882C11.6667 15.9763 11.6667 16.762 11.6667 18.3333V28.3333C11.6667 29.9047 11.6667 30.6904 11.1785 31.1785C10.6904 31.6667 9.90468 31.6667 8.33333 31.6667C6.76199 31.6667 5.97631 31.6667 5.48816 31.1785C5 30.6904 5 29.9047 5 28.3333V18.3333Z"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                    />
                    <path
                      d="M16.666 11.6663C16.666 10.095 16.666 9.30932 17.1542 8.82116C17.6423 8.33301 18.428 8.33301 19.9993 8.33301C21.5707 8.33301 22.3564 8.33301 22.8445 8.82116C23.3327 9.30932 23.3327 10.095 23.3327 11.6663V28.333C23.3327 29.9044 23.3327 30.69 22.8445 31.1782C22.3564 31.6663 21.5707 31.6663 19.9993 31.6663C18.428 31.6663 17.6423 31.6663 17.1542 31.1782C16.666 30.69 16.666 29.9044 16.666 28.333V11.6663Z"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                    />
                    <path
                      d="M28.334 6.66634C28.334 5.09499 28.334 4.30932 28.8221 3.82116C29.3103 3.33301 30.096 3.33301 31.6673 3.33301C33.2387 3.33301 34.0243 3.33301 34.5125 3.82116C35.0007 4.30932 35.0007 5.09499 35.0007 6.66634V28.333C35.0007 29.9044 35.0007 30.69 34.5125 31.1782C34.0243 31.6663 33.2387 31.6663 31.6673 31.6663C30.096 31.6663 29.3103 31.6663 28.8221 31.1782C28.334 30.69 28.334 29.9044 28.334 28.333V6.66634Z"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                    />
                  </svg>
                  <p>{t("Absolutely transparent accrual statistics")}</p>
                </div>
                <div className={styles.block}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="41"
                    height="40"
                    viewBox="0 0 41 40"
                    fill="none"
                  >
                    <path
                      d="M16.6338 6.48411C17.5735 5.68323 18.0434 5.28279 18.5347 5.04797C19.6711 4.50484 20.9921 4.50484 22.1284 5.04797C22.6197 5.28279 23.0896 5.68323 24.0294 6.48411C24.4034 6.80286 24.5904 6.96224 24.7902 7.09611C25.248 7.40299 25.7622 7.61597 26.303 7.72273C26.5389 7.7693 26.7838 7.78885 27.2737 7.82794C28.5045 7.92617 29.1199 7.97528 29.6334 8.15663C30.8209 8.57609 31.755 9.51018 32.1745 10.6977C32.3558 11.2112 32.4049 11.8266 32.5032 13.0574C32.5422 13.5473 32.5618 13.7922 32.6084 14.0281C32.7151 14.5689 32.9281 15.0831 33.235 15.5409C33.3689 15.7407 33.5282 15.9277 33.847 16.3017C34.6479 17.2415 35.0483 17.7114 35.2831 18.2027C35.8263 19.339 35.8263 20.66 35.2831 21.7964C35.0483 22.2877 34.6479 22.7575 33.847 23.6973C33.5282 24.0714 33.3689 24.2584 33.235 24.4581C32.9281 24.916 32.7151 25.4302 32.6084 25.9709C32.5618 26.2068 32.5422 26.4518 32.5032 26.9416C32.4049 28.1725 32.3558 28.7879 32.1745 29.3013C31.755 30.4889 30.8209 31.423 29.6334 31.8424C29.1199 32.0238 28.5045 32.0729 27.2737 32.1711C26.7838 32.2102 26.5389 32.2298 26.303 32.2763C25.7622 32.3831 25.248 32.5961 24.7902 32.903C24.5904 33.0368 24.4034 33.1962 24.0294 33.515C23.0896 34.3158 22.6197 34.7163 22.1284 34.9511C20.9921 35.4942 19.6711 35.4942 18.5347 34.9511C18.0434 34.7163 17.5735 34.3158 16.6338 33.515C16.2597 33.1962 16.0727 33.0368 15.873 32.903C15.4151 32.5961 14.9009 32.3831 14.3602 32.2763C14.1243 32.2298 13.8793 32.2102 13.3895 32.1711C12.1586 32.0729 11.5432 32.0238 11.0298 31.8424C9.84221 31.423 8.90812 30.4889 8.48866 29.3013C8.30731 28.7879 8.2582 28.1725 8.15997 26.9416C8.12088 26.4518 8.10134 26.2068 8.05476 25.9709C7.94801 25.4302 7.73502 24.916 7.42814 24.4581C7.29427 24.2584 7.1349 24.0714 6.81614 23.6973C6.01526 22.7575 5.61482 22.2877 5.38 21.7964C4.83688 20.66 4.83688 19.339 5.38 18.2027C5.61482 17.7114 6.01526 17.2415 6.81614 16.3017C7.1349 15.9277 7.29427 15.7407 7.42814 15.5409C7.73502 15.0831 7.94801 14.5689 8.05476 14.0281C8.10134 13.7922 8.12088 13.5473 8.15997 13.0574C8.2582 11.8266 8.30731 11.2112 8.48866 10.6977C8.90812 9.51018 9.84221 8.57609 11.0298 8.15663C11.5432 7.97528 12.1586 7.92617 13.3895 7.82794C13.8793 7.78885 14.1243 7.7693 14.3602 7.72273C14.9009 7.61597 15.4151 7.40299 15.873 7.09611C16.0727 6.96224 16.2597 6.80286 16.6338 6.48411Z"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                    />
                    <path
                      d="M15.332 25L25.332 15"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M25.6654 24.1667C25.6654 24.811 25.143 25.3333 24.4987 25.3333C23.8544 25.3333 23.332 24.811 23.332 24.1667C23.332 23.5223 23.8544 23 24.4987 23C25.143 23 25.6654 23.5223 25.6654 24.1667Z"
                      fill="#39C5CA"
                      stroke="#39C5CA"
                    />
                    <path
                      d="M17.3314 15.8337C17.3314 16.478 16.809 17.0003 16.1647 17.0003C15.5204 17.0003 14.998 16.478 14.998 15.8337C14.998 15.1893 15.5204 14.667 16.1647 14.667C16.809 14.667 17.3314 15.1893 17.3314 15.8337Z"
                      fill="#39C5CA"
                      stroke="#39C5CA"
                    />
                  </svg>
                  <p>
                    {t("Well-established algorithm and high conversion rate")}
                  </p>
                </div>
              </div>
              <div className={styles.bottom_blocks}>
                <div className={styles.block}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="41"
                    height="40"
                    viewBox="0 0 41 40"
                    fill="none"
                  >
                    <path
                      d="M37.3318 18.3337C37.3166 13.1432 37.1525 10.3914 35.3807 8.61961C33.4281 6.66699 30.2854 6.66699 24 6.66699H17.3333C11.0479 6.66699 7.90524 6.66699 5.95262 8.61961C4 10.5722 4 13.7149 4 20.0003C4 26.2857 4 29.4284 5.95262 31.381C7.90524 33.3337 11.0479 33.3337 17.3333 33.3337H19.8333"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M26.5003 23.333V33.333M26.5003 33.333L29.8337 29.9997M26.5003 33.333L23.167 29.9997M34.0003 33.333V23.333M34.0003 23.333L37.3337 26.6663M34.0003 23.333L30.667 26.6663"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.3337 26.667H10.667"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M4 16.667L37.3333 16.667"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                  <p>
                    {t(
                      "Flexible individual terms and commission-free payments"
                    )}
                  </p>
                </div>
                <div className={styles.block}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                  >
                    <circle
                      cx="20.0007"
                      cy="9.99967"
                      r="6.66667"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                    />
                    <path
                      d="M30 15.0003C32.7614 15.0003 35 13.1348 35 10.8337C35 8.53247 32.7614 6.66699 30 6.66699"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M10 15.0003C7.23858 15.0003 5 13.1348 5 10.8337C5 8.53247 7.23858 6.66699 10 6.66699"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <ellipse
                      cx="20"
                      cy="28.3337"
                      rx="10"
                      ry="6.66667"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                    />
                    <path
                      d="M33.334 31.6663C36.2577 31.0252 38.334 29.4014 38.334 27.4997C38.334 25.5979 36.2577 23.9742 33.334 23.333"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M6.66602 31.6663C3.74227 31.0252 1.66602 29.4014 1.66602 27.4997C1.66602 25.5979 3.74227 23.9742 6.66602 23.333"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                  <p>{t("Personal work with each program participant")}</p>
                </div>
                <div className={styles.block}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="41"
                    height="40"
                    viewBox="0 0 41 40"
                    fill="none"
                  >
                    <path
                      d="M36.9994 17.4997V19.9997C36.9994 27.8564 36.9994 31.7848 34.5586 34.2256C32.1178 36.6663 28.1894 36.6663 20.3327 36.6663C12.4759 36.6663 8.54757 36.6663 6.10679 34.2256C3.66602 31.7848 3.66602 27.8564 3.66602 19.9997C3.66602 12.1429 3.66602 8.21456 6.10679 5.77378C8.54757 3.33301 12.4759 3.33301 20.3327 3.33301H22.8327"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <ellipse
                      cx="31.998"
                      cy="8.33301"
                      rx="5"
                      ry="5"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                    />
                    <path
                      d="M11.998 23.3337L15.8195 19.5122C16.4704 18.8613 17.5257 18.8613 18.1766 19.5122L20.8195 22.1551C21.4704 22.806 22.5257 22.806 23.1766 22.1551L28.6647 16.667M28.6647 16.667V20.8337M28.6647 16.667H24.498"
                      stroke="#39C5CA"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <p>{t("A wide range of proven marketing materials")}</p>
                </div>
              </div>
            </div>
            <Link to="/cabinet">
              {t("Become a partner")}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
              >
                <path
                  d="M4.5 12L12.5 4M12.5 4L12.5 10M12.5 4L6.5 4"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="square"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.section2}>
        <div className={styles.section2Body}>
          <div className={styles.title}>
            <h1>
              {t("Synergy Assets offers its partners three cooperation options to choose from:")}
            </h1>
          </div>
          <div className={styles.blocks}>
            <div className={styles.block}>
              <span className={styles.number}>
                <img src={Icon1} alt="icon" />
              </span>
              <div className={styles.text}>
                <h5>{t("REVENUE SHARE - FROM 30% TO 45%")}</h5>
                <p>
                  {t(
                    "Throughout the time of work of the client you have brought in, you receive a percentage of his income."
                  )}
                  <br />
                  <br />
                  {t(
                    "The size of the interest rate depends directly on the number and activity of your clients."
                  )}
                </p>
              </div>
            </div>
            <div className={styles.block}>
              <span className={styles.number}>
                <img src={Icon2} alt="icon" />
              </span>
              <div className={styles.text}>
                <h5>CPA</h5>
                <p>
                  {t(
                    "You will receive a one-time fixed payment for each client who opens a deposit with Synergy Assets."
                  )}
                </p>
                <br />
                <p>
                  {t(
                    "The size of the CPA can increase along with the number of invited clients. The terms of cooperation are discussed individually with each partner."
                  )}
                </p>
              </div>
            </div>
            <div className={styles.block}>
              <span className={styles.number}>
                <img src={Icon3} alt="icon" />
              </span>
              <div className={styles.text}>
                <h5>{t("CPA + REVENUE SHARE")}</h5>
                <p>
                  {t(
                    "A convenient form of cooperation that combines a deposit rate and a regular percentage of the client's income."
                  )}
                </p>
                <br />
                <p>
                  {t(
                    "To get personal terms of work, please contact the affiliate program manager."
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.section3}>
        <div className={styles.section3Body}>
          <div className={styles.top}>
            <h1>{t("Join the Synergy Assets affiliate program today!")}</h1>
            <p>
              {t(
                "Earn profit on favorable terms. Simply fill out the registration form, after which the affiliate program manager will contact you to complete the registration of your account."
              )}
            </p>
          </div>
          <div className={styles.form}>
            <div className={styles.inputs}>
              <div className={styles.input_label}>
                <label htmlFor="">{t("Name")}</label>
                <input type="text" placeholder={t("Name")} />
              </div>
              <div className={styles.input_label}>
                <label htmlFor="">{t("Surname")}</label>
                <input type="text" placeholder={t("Surname")} />
              </div>
              <div className={styles.input_label}>
                <label htmlFor="">{t("Phone")}</label>
                <input type="text" placeholder={t("Phone")} />
              </div>
              <div className={styles.input_label}>
                <label htmlFor="">{t("Email")}</label>
                <input type="text" placeholder={t("Email")} />
              </div>
            </div>
            <div className={styles.textarea_block}>
              <label htmlFor="">{t("Message")}</label>
              <textarea
                name="Message"
                id=""
                placeholder={t("Message")}
              ></textarea>
            </div>
            <div className={styles.link_block}>
              <Link to="/cabinet">{t("Become a partner")}<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
  <path d="M1.5 9L9.5 1M9.5 1L9.5 7M9.5 1L3.5 1" stroke="white" stroke-width="1.5" stroke-linecap="square"/>
</svg></Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
